import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2Cliente } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import * as SocioCrud from 'services/socio.service'

const ClienteFormGroup = ({ value, setValue, limpiarTabla }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      setValue({ ...data, _id: pickedMember.value })
    })
    limpiarTabla()
  }

  const clickClear = () => {
    setValue(null)
    limpiarTabla()
  }

  return (
    <>
      <Form.Group>
        <Form.Label text='CLIENTE' htmlFor='input-codigoRucSocio' md={3} />
        <Col md={6}>
          {value ? (
            <ClearInputGroup id='input-codigoRucSocio' iValue={`${value.numeroDocumento} - ${value.razonSocial}`} clickClear={clickClear} />
          ) : (
            <Select2Cliente id='codigoRucSelect' onChange={onChangeSocioHandler} />
          )}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(ClienteFormGroup)
